import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Separator, Text, useTheme } from '@ublend-npm/aulaui-core';

import { getCurrentSpaceName } from '@core/selectors/space';

const ParticipantHistoryTitle = () => {
  const spaceName = useSelector(getCurrentSpaceName);

  const theme = useTheme();

  return (
    <Box>
      <Text kind="h4">Participant history</Text>
      <Text color={theme.palette.text.secondary} sx={{ lineHeight: 2 }}>
        {spaceName}
      </Text>
      <Separator size="thin" sx={{ pt: { xs: 1.5, lg: 2.5 } }} />
    </Box>
  );
};

export default ParticipantHistoryTitle;
